/**
 * Application-wide constants
 */
export * from './ai-feedback.js';
export * from './deal-document-upload.js';
import { DEAL_DOCUMENT_EXTENSIONS, DEAL_DOCUMENT_MIME_TYPES } from './deal-document-upload.js';
export const APP_NAME = 'Protoss';
export const APP_VERSION = '0.1.0';
/**
 * HTTP Status Codes
 */
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500,
    SERVICE_UNAVAILABLE: 503,
};
/**
 * Environment types
 */
export const ENVIRONMENTS = {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production',
    TEST: 'test',
};
/**
 * Transcript upload caps - shared contract across tiers. The web upload surfaces (deal page modal,
 * create-from-script panel) use TRANSCRIPT_MAX_FILES to cap selection. NOTE: the AI-chat ask_user
 * upload caps (create-deal, transcript analysis, reference-estimate import) are now PER-WORKSPACE
 * TUNABLES (ai.transcript_max_files / ai.transcript_max_bytes / ai.reference_estimate_max_files,
 * resolved via RUNTIME_TUNABLE_DEFAULTS) so they can be raised from observed usage without a
 * redeploy; these constants are the web-surface cap + the engine-default fallback (kept in sync).
 */
export const TRANSCRIPT_ACCEPT_MIME = [...DEAL_DOCUMENT_MIME_TYPES];
/** Extension fallback for the same list (browsers often send a blank/generic type for .eml, .yaml, .md). */
export const TRANSCRIPT_ACCEPT_EXTENSIONS = [...DEAL_DOCUMENT_EXTENSIONS];
/** Per-file byte ceiling hint for transcript uploads (25 MB). Engine default for ai.transcript_max_bytes. */
export const TRANSCRIPT_MAX_BYTES = 25 * 1024 * 1024;
/**
 * Max transcript files a user may upload in one analysis (web-surface cap + engine default for
 * ai.transcript_max_files). Several recorded calls (discovery, technical, procurement) can populate
 * one deal; cost/latency scale with the count, so this caps the fan-out. Raised 5 -> 20 on
 * 2026-08-25: real engagements arrive as a folder of calls, and the per-workspace tunable can still
 * lower it without a redeploy.
 */
export const TRANSCRIPT_MAX_FILES = 20;
/**
 * THE document size contract: the maximum number of CHARACTERS of raw text one document
 * may carry in one submission (plan 50, 2026-09-18). One number, stated in the unit the
 * caller counts in and the discovery engine chunks in.
 *
 * It lives here because it has to be identical in two apps that cannot import each
 * other: the MCP tool schemas (`document`, `documents[].text`), where the caller reads
 * the limit and the remedy, and the API's document-estimation route, which enforces the
 * same number for any direct caller. The byte caps under it are HEADROOM, deliberately
 * sized so this limit binds first for ordinary transcript text: 8 MiB Fastify
 * `bodyLimit` on both servers, 4 MiB `DOCUMENT_MAX_BYTES` in the API service.
 *
 * Why 2,000,000 and not the largest document anyone has sent: the biggest document in
 * House Blend's production corpus is 99,997 characters and a full-day multi-speaker
 * transcript runs 300-500k, so this is a guard against a caller pasting an entire export
 * (the 1.16M- and 4.78M-character files reported on 2026-09-16), not a working budget.
 * Above it, the answer is more calls - one meeting or one thread each - never a summary.
 */
export const DOCUMENT_MAX_CHARS = 2_000_000;
export * from './ui-control-catalog.js';
export * from './salesforce-bpr-categories.js';
export * from './salesforce-bpr-driver-map.js';
export * from './sow-products.js';
//# sourceMappingURL=index.js.map